import { ProcedureStatus, Role, WaypointStatusFulfillmentOrder, WaypointStatusName } from '@caresend/types';
import { hasStatus, isNullish, asyncTimeout, formatCamelCase } from '@caresend/utils';
import { defineComponent, computed, ref, watchEffect } from 'vue';
import __vue_component__$1 from '../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$5 from '../../../../../inputs/SwitchComponent.vue.js';
import __vue_component__$2 from '../../ItineraryList/components/ExpandCopyID.vue.js';
import __vue_component__$4 from '../../ItineraryList/components/ItineraryRelatedStatusView.vue.js';
import { getProcedureTagInfos } from './WaypointProcedureCard/tags.js';
import { usePortalStore } from '../../../store/portal/index.js';
import __vue_component__$3 from '../../../../../ui/InteractivePopup/InteractivePopup.vue.js';
import __vue_component__$6 from '../../../../../ui/Tag/Tag.vue.js';
import 'immutability-helper';
import { getRouter } from '../../../../../../router/helpers/initRouter.js';
import '../../../../../../router/routes/dev/model.js';
import '../../../../../../router/routes/dev/routes.js';
import '../../../../../../router/routes/dashboard/model.js';
import '../../../../../../router/routes/pro/model.js';
import '../../../../../../router/routes/visitsPage/model.js';
import '../../../../../../router/routes/orderFlow/model.js';
import '../../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../../router/routes/orderFlow/routes.js';
import '../../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../../router/routes/chartingFlow/model.js';
import '../../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../../router/routes/portal/portalRoutes.js';
import { portalProcedureRoute } from '../../../../../../router/routes/portal/locations.js';
import '../../../../../../router/routes/portal/model.js';
import '../../../../../../router/routes/visitsPage/routes.js';
import '../../../store/portal/sessionStore.js';
import 'file-saver';
import '../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../../../store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../../../../database/firebaseConfig/init.js';
import '../../../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../../ui/Icon.vue.js';
import '../../../../../../functions/configuration/icons.js';
import '../../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../../functions/tracking/index.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import '../../../../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../../../../store/pinia/draftWaypoints/index.js';
import '../../../../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../../../../store/modules/chartingFlow/model.js';
import '../../../../../../store/modules/office/index.js';
import '../../../../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../../../../store/modules/office/model.js';
import '../../../../../../store/modules/orderFlow/index.js';
import '../../../../../../store/modules/procedures/model.js';
import '../../../../../../store/modules/schedulingFlow/index.js';
import '../../../../../../store/modules/schedulingFlow/model.js';

var script = defineComponent({
    name: 'ProcedureInfoStatusPopup',
    components: {
        BasicCard: __vue_component__,
        ButtonComponent: __vue_component__$1,
        ExpandCopyID: __vue_component__$2,
        InteractivePopup: __vue_component__$3,
        ItineraryRelatedStatusView: __vue_component__$4,
        SwitchComponent: __vue_component__$5,
        Tag: __vue_component__$6,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        justify: {
            type: String,
            default: 'start',
        },
        isMinimizedView: {
            type: Boolean,
            default: false,
        },
        procedures: {
            type: Array,
            default: () => [],
        },
        waypointActionID: {
            type: String,
            default: undefined,
        },
        waypointStatus: {
            type: String,
            default: undefined,
        },
    },
    setup(props, { emit }) {
        var _a, _b;
        const portalStore = usePortalStore();
        const { viewAs } = portalStore;
        const router = getRouter();
        const { user } = getStore().state.auth;
        const singleProcedure = computed(() => (!props.isMinimizedView && props.procedures[0]) || undefined);
        const updateStatus = (status) => {
            const procedure = singleProcedure.value;
            if (!(procedure === null || procedure === void 0 ? void 0 : procedure.id))
                return;
            portalStore.procedures.setChildOf(procedure.id, 'status', status, 'set procedure status');
        };
        const isOpened = ref(false);
        const updateIsOpened = (value) => {
            isOpened.value = value;
            return asyncTimeout(100);
        };
        const openProcedurePage = async () => {
            if (props.procedures.length !== 1)
                return;
            const procedure = props.procedures[0];
            if (!(procedure === null || procedure === void 0 ? void 0 : procedure.id))
                return;
            await updateIsOpened(false);
            const route = portalProcedureRoute(procedure.id);
            router.push(route);
        };
        const singleProcedureScanning = ref(!((_a = singleProcedure.value) === null || _a === void 0 ? void 0 : _a.disableSampleScanning));
        const singleProcedureProcessing = ref(!((_b = singleProcedure.value) === null || _b === void 0 ? void 0 : _b.disableSampleProcessing));
        watchEffect(() => {
            var _a, _b;
            singleProcedureScanning.value = !((_a = singleProcedure.value) === null || _a === void 0 ? void 0 : _a.disableSampleScanning);
            singleProcedureProcessing.value = !((_b = singleProcedure.value) === null || _b === void 0 ? void 0 : _b.disableSampleProcessing);
        });
        const singleProcedureStatus = computed(() => { var _a; return (_a = singleProcedure.value) === null || _a === void 0 ? void 0 : _a.status; });
        const setScanning = (scanning) => {
            if (!singleProcedure.value)
                return;
            portalStore.procedures.setChildOf(singleProcedure.value.id, 'disableSampleScanning', !scanning, `set procedure ${formatCamelCase('disableSampleScanning')}`);
        };
        const setProcessing = (processing) => {
            if (!singleProcedure.value)
                return;
            portalStore.procedures.setChildOf(singleProcedure.value.id, 'disableSampleProcessing', !processing, `set procedure ${formatCamelCase('disableSampleProcessing')}`);
        };
        /** Currently only supports the first procedure in the passed array */
        const processingIncludesCentrifuge = computed(() => { var _a, _b, _c; return !!((_c = (_b = (_a = props.procedures[0]) === null || _a === void 0 ? void 0 : _a.supplyInstructionConfig) === null || _b === void 0 ? void 0 : _b.processingIncludes) === null || _c === void 0 ? void 0 : _c.centrifuge); });
        const canPerformProcedureCancelation = computed(() => props.procedures.every((p) => props.waypointActionID && !hasStatus(p, [ProcedureStatus.COMPLETED, ProcedureStatus.FAILED])));
        const isNurse = computed(() => (user === null || user === void 0 ? void 0 : user.role) === Role.NURSE);
        const cancelProceduresDisabled = computed(() => hasStatus(singleProcedure.value, ProcedureStatus.CANCELED));
        const procedureOptionsAvailable = computed(() => {
            const atWaypointOrder = WaypointStatusFulfillmentOrder[WaypointStatusName.AT_WAYPOINT];
            const currentStatusOrder = props.waypointStatus ? WaypointStatusFulfillmentOrder[props.waypointStatus] : 0;
            return !isNurse.value || (currentStatusOrder >= atWaypointOrder);
        });
        const cancelProcedures = async () => {
            await updateIsOpened(false);
            props.procedures.forEach((p) => emit('cancelProcedure', {
                procedureID: p.id,
                waypointActionID: props.waypointActionID,
            }));
        };
        /** Collect labels for all procedures and process them to add count for every unique label */
        const tags = computed(() => {
            const allTags = props.procedures.map(getProcedureTagInfos).flat();
            const uniqueTags = new Set(allTags.map((tag) => tag.label));
            return Array.from(uniqueTags).map((label) => ({
                ...allTags.find((tag) => tag.label === label),
                count: allTags.filter((tag) => tag.label === label).length,
            })).filter((tag) => (!isNullish(tag.label)
                && !isNullish(tag.icon)
                && !isNullish(tag.tagStyle)));
        });
        return {
            ProcedureStatus,
            canPerformProcedureCancelation,
            cancelProcedures,
            cancelProceduresDisabled,
            isNurse,
            isOpened,
            openProcedurePage,
            procedureOptionsAvailable,
            processingIncludesCentrifuge,
            setProcessing,
            setScanning,
            singleProcedureProcessing,
            singleProcedureScanning,
            singleProcedureStatus,
            tags,
            updateIsOpened,
            updateStatus,
            viewAs,
        };
    },
});

export { script as default };
